/**
 * Created by an.han on 16/10/15.
 */


// 生成 mutations 方法
function generate(name) {
    return function (state, value) {
        state[name] = value || state[name];
    }
}

const options = {

    // 多页面共享数据
    state: {
        token: localStorage.getItem('Token') ? localStorage.getItem('Token') : '',
        message: ''
    },

    // 操作
    actions: {},

    // 数据变更
    mutations: {
        // 修改token，并将token存入localStorage
        changeLogin (state, user) {
            localStorage.setItem('Token', user.token);
            //state.token = user.token;

        }
    },
}

// 为每个 state 字段生成对应的 mutations 方法
Object.keys(options.state).forEach((key) => {
    options.mutations[key] = generate(key);
});

export default options;


// WEBPACK FOOTER //
// ./src/vuex/store.js